import 'css-chunksrc/client/pages/zonesPage/projectsPage/zone/loader/project/styles.scss';export default {
  "project": "_project_fiqzr_1"
};